import React, { useEffect, useState } from "react";
import { Box, InputBase, Paper, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useDebounce } from "../../utils";

export default function CustomSearchBar({ handleChange, placeholder }) {
  const [searchQuery, setSearchQuery] = useState("");
  const debouncedSearchTerm = useDebounce(searchQuery, 500);
  useEffect(() => {
    handleChange(debouncedSearchTerm);
  }, [debouncedSearchTerm]);

  const handleInputChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      // Prevent default form submission or any action on Enter key press
      event.preventDefault();
    }
  };
  return (
    <Paper
      component="form"
      sx={{
        display: "flex",
        alignItems: "center", // Align items vertically
        margin: "auto", // Center the component horizontally
        padding: "4px px", // Internal spacing
        marginBottom: "0px", // Spacing from other components
        boxShadow: "0 4px 6px rgba(0,0,0,0.1)", // Subtle shadow
        height: "50px", // Ensure consistent height with other components
      }}
    >
      <InputBase
        sx={{
          ml: 1, // Margin-left for spacing
          flex: 1, // Expand to fill available space
          pl: 1, // Padding-left for better spacing inside
          fontSize: "16px", // Match font size with other components
          lineHeight: "1.5", // Ensure consistent text alignment
        }}
        placeholder={placeholder}
        inputProps={{ "aria-label": "search" }}
        value={searchQuery}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown} // Handle the key down event
      />
      {/* <IconButton
        type="button"
        sx={{ p: "10px" }}
        aria-label="search"
        onClick={handleSearch}
      > */}
      <SearchIcon sx={{ p: "10px" }} />
      {/* </IconButton> */}
    </Paper>
  );
}
